import { ScreenSize, useScreenSize } from './useScreenSize';

const mobileScreenSizes = [ScreenSize.md, ScreenSize.sm, ScreenSize.xs]

export function useIsMobile(): boolean {
	const [, screenSize] = useScreenSize()
	return  mobileScreenSizes.some(sz => sz === screenSize)
}
